var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "water",
    patternUnits: "userSpaceOnUse",
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#1e90ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20 Q25 10 50 20 T100 20",
    stroke: "#00bfff",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 50 Q25 40 50 50 T100 50",
    stroke: "#87cefa",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80 Q25 70 50 80 T100 80",
    stroke: "#00bfff",
    strokeWidth: 5,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#water)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.fb1dc4eaef1c9d5184945ce939ea42e3.svg";
export { ForwardRef as ReactComponent };